export default "__VITE_ASSET__CdSJ6t2K__"